import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { User } from '@account-users/user/models/User';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-user-ui-preferences',
  templateUrl: './user-ui-preferences.component.html',
  styleUrls: ['./user-ui-preferences.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserUIPreferencesComponent {
  @Input() set user(user: User) {
    try {
      const prefsObj: Record<string, string> = JSON.parse(
        user?.uiPreferences ?? '',
      );
      const prefsList = Object.entries(prefsObj).map(([name, value]) => ({
        name,
        value,
      }));
      this.uiPreferences$.next(prefsList);
    } catch {
      this.uiPreferences$.next([]);
    }
  }
  public readonly uiPreferences$ = new BehaviorSubject<
    { name: string; value: string }[]
  >([]);
}
